/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

/* eslint-disable import/prefer-default-export */
/* eslint-disable no-undef */

export const onInitialClientRender = () => {
  const jssStyles = document.querySelector('#jss-server-side');
  if (jssStyles && jssStyles.parentElement) {
    jssStyles.parentElement.removeChild(jssStyles);
  }
};
